<template>
  <div class="flex items-start flex-wrap">
    <div
      class="field w-full"
      :style="marginStyle"
    >
      <div class="relative">
        <div
          id="cardComponent"
          ref="cardComponent"
          class="input-field"
          :class="updatedSuccessfully ? 'field-updated' : ''"
          :style="paddingStyle"
        />
      </div>
      <div
        v-show="error.length > 0"
        class="error-message text-xs"
        v-html="error"
      />
    </div>
  </div>
</template>

<script>
import { PAYMENT_METHODS } from '@/constants';
import { eventTracker } from '@/utils/eventTracker';
import analyticsEvents from '@/utils/analyticsEvents';

export default {
  props: {
    updatedSuccessfully: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: '',
    };
  },
  computed: {
    paddingStyle() {
      return {
        'padding-top': '0.85rem',
      };
    },
    marginStyle() {
      return {
        'margin-top': 0,
      };
    },
    paymentMethod() {
      return this.$store.getters.paymentMethod;
    },
    chargebeeInstance() {
      return this.$store.getters.chargebeeInstance;
    },
  },
  mounted() {
    if (this.paymentMethod === PAYMENT_METHODS.CHARGEBEE) {
      this.renderChargebeeCardComponent();
    }
  },
  methods: {
    renderChargebeeCardComponent() {
      const fonts = [{
        fontFamily: 'Artlist Sans',
        src: '/assets/fonts/artlist/ArtlistSans-Regular.woff2',
        fontWeight: 400,
      }];
      const locale = 'en';
      const classes = {
        focus: 'focused',
        empty: 'empty',
        invalid: 'invalid',
        complete: 'complete',
      };
      const style = {
        base: {
          color: '#fff',
        },

        invalid: {
          color: '#ee5951',
          iconColor: '#ee5951',
        },
      };
      const cardOptions = {
        icon: true,
        fonts,
        locale,
        classes,
        style,
        placeholder: {
          number: '',
          expiry: '',
          cvv: '',
        },
      };

      this.chargebeeInstance.load('components').then(() => {
        // Create card component
        const cardComponent = this.chargebeeInstance.createComponent('card', cardOptions);

        // Credit card validation
        cardComponent.on('change', (currentState) => {
          if (currentState.empty) {
            if (currentState.error) {
              this.error = currentState.error.message;
              this.$emit('card-valid', false);
              this.$emit('card-error', currentState.error.message);
            }
          } else if (currentState.error) {
            this.error = currentState.error.message;
            this.$emit('card-valid', false);
            this.$emit('card-error', currentState.error.message);
          } else if (currentState.complete) {
            this.error = '';
            this.$emit('card-valid', true);
            this.$emit('card-error', '');
            this.chargebeeCardComponent = cardComponent;
          } else {
            this.error = '';
          }
        });
        cardComponent.on('focus', () => {
          this.error = '';
          this.$emit('card-error', '');
          eventTracker(analyticsEvents.textBoxClicked, {
            text_box_name: 'Credit Card',
            click_source: 'my account- payment method tab',
          });
        });
        cardComponent.on('blur', (currentState) => {
          if (currentState.empty) {
            eventTracker(analyticsEvents.textBoxClicked, {
              text_box_name: 'Credit Card',
              click_source: 'my account- payment method tab',
            });
          } else {
            eventTracker(analyticsEvents.textBoxFilled, {
              text_box_name: 'Credit Card',
              click_source: 'my account- payment method tab',
              value: null,
            });
          }
        });
        this.$emit('chargebee-card-component', cardComponent);
        cardComponent.mount('#cardComponent');
      }).catch((err) => {
        console.error('Failed to load chargebee card component', err);
        throw err;
      });
    },
  },
};
</script>

<style scoped>
  .input-field {
    @apply w-full rounded-md h-12 px-3 pr-8 outline-none bg-transparent text-primary-offwhite;
    border: 1px solid #B3B3B3;
    font-family: 'Artlist Sans';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .input-field.focused {
      @apply border-primary-offwhite text-primary-offwhite;
  }
  label,
  .placeholder {
      @apply absolute pointer-events-none;
      color: #B3B3B3;
      left: 12px;
      top: calc(50% - 12px);
      transition: all 0.3s;
  }
  .placeholder {
      opacity: 0;
  }
  .input-field.empty.focused ~ .placeholder {
      opacity: 1;
  }
  .input-field.focused + label,
  .input-field:not(.empty) + label {
      left: 0px;
      transform: scale(0.75) translateY(-32px);
      background-color: white;
      padding-left: 6px;
      padding-right: 6px;
      color: #534CDA;
  }
  .input-field.invalid,
  .input-field.empty {
      border: 1px solid #ee5951;
  }
  .input-field.empty.field-updated {
      border: 1px solid #B3B3B3;
  }
  .input-field.empty ~ .placeholder {
    color: #ee5951;
  }
  .input-field.invalid + label,
  .input-field.empty + label {
      color: #ee5951;
  }
  .input-field.empty.focused {
    @apply border-primary-offwhite text-primary-offwhite;
  }

  .field {
      @apply relative my-4;
  }
  .error-message {
      color: #ee5951;
  }
</style>
